import React, { useEffect, useState } from "react";
import { useAgentCommissionByIdMutation } from "../../service/users";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import {
  AgentList,
  CommonBody,
  CompanyList,
  UsersList,
} from "../../types/General";
import { errorToast, successToast } from "../../helpers";
import {
  Button,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
  Switch,
  TextField,
} from "@mui/material";
import Loader from "../../constants/Loader";

type props = {
  id: string | undefined;
  details: UsersList | CompanyList | AgentList | null;
};
const AgentCommission = ({ id, details }: props) => {
  const [commssionType, setCommisionType] = useState("1");
  const [commsionValue, setCommssionValue] = useState("");
  const [hasExtraBenifits, setHasExtraBenifits] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [agentCommssion] = useAgentCommissionByIdMutation();

  const handleSubmit = async () => {
    setLoading(true);
    setError(true);
    if (hasExtraBenifits && !commsionValue?.length) {
      return;
    }
    const body = {
      benefit_for_agent: hasExtraBenifits ? Number(commsionValue) : "",
      benefit_for_agent_type: hasExtraBenifits ? Number(commssionType) : null,
      benefit_provided: hasExtraBenifits,
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await agentCommssion({
        body: encryptedBody,
        id: Number(id),
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        successToast("Details updated successfully");
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleCommissionType = (event: SelectChangeEvent) => {
    setCommisionType(event.target.value as string);
    setCommssionValue("");
  };
  const label = { inputProps: { "aria-label": "Switch demo" } };
  useEffect(() => {
    setHasExtraBenifits(details?.benefit_provided || false);
    setCommisionType(details?.benefit_for_agent_type?.toString() || "1");
    setCommssionValue(details?.benefit_for_agent?.toString() || "");
  }, [details]);

  return (
    <div className="profileInfo_list">
      <Loader isLoad={loading} />
      <ul className="text_info gap_p">
        <div className="control_group w_50">
          <label>Give extra benefits?</label>
          <span>
            <Switch
              {...label}
              checked={hasExtraBenifits}
              onChange={() => setHasExtraBenifits(!hasExtraBenifits)}
            />
          </span>
        </div>
        <div className="control_group w_50" />
        {hasExtraBenifits ? (
          <>
            <div className="control_group w_50">
              <label>Commission Type</label>
              <Select
                fullWidth
                value={commssionType}
                onChange={handleCommissionType}
              >
                <MenuItem value={1}>Percentage</MenuItem>
                <MenuItem value={2}>Flat</MenuItem>
              </Select>
            </div>
            <div className="control_group w_50">
              <label>Commssion Value</label>
              {/* <TextField
                hiddenLabel
                variant="outlined"
                placeholder="Commission"
                fullWidth
                value={commsionValue}
                inputProps={{ maxLength: Number(commssionType) === 1 ? 3 : 11 }}
                onChange={(e) => {
                  let value = e.target.value;

                  if (!/^\d*\.?\d*$/.test(value)) {
                    return;
                  }
                  // Restrict value to 100 if type === 1
                  if (Number(commssionType) === 1 && parseFloat(value) > 100) {
                    errorToast("Commission cannot be more than 100%");

                    value = "100";
                  }

                  setCommssionValue(value);
                }}
                InputProps={{
                  endAdornment:
                    Number(commssionType) === 1 ? (
                      <InputAdornment position="end">%</InputAdornment>
                    ) : null,
                }}
              /> */}
              <TextField
                hiddenLabel
                variant="outlined"
                placeholder="Commission"
                fullWidth
                value={commsionValue}
                inputProps={{
                  maxLength: Number(commssionType) === 1 ? 6 : 12, // allow e.g., '100.00'
                }}
                onChange={(e) => {
                  let value = e.target.value;

                  // Allow only numbers with up to two decimal places
                  if (!/^\d{0,9}(\.\d{0,2})?$/.test(value)) {
                    return;
                  }

                  // Cap percentage value at 100
                  if (Number(commssionType) === 1 && parseFloat(value) > 100) {
                    errorToast("Commission cannot be more than 100%");
                    value = "100";
                  }

                  setCommssionValue(value);
                }}
                InputProps={{
                  endAdornment:
                    Number(commssionType) === 1 ? (
                      <InputAdornment position="end">%</InputAdornment>
                    ) : null,
                }}
              />
              {error && hasExtraBenifits && !commsionValue?.length ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>
          </>
        ) : null}

        <div className="form_btn end">
          <Button className="btn btn_secondary" onClick={handleSubmit}>
            Save Changes
          </Button>
        </div>
      </ul>
    </div>
  );
};

export default AgentCommission;
